var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#18174a;}.cls-2{fill:#2b69b3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_16.OFFICE",
    "data-name": " 16.OFFICE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,5.85H21.5V1.28a1,1,0,0,0-1-1H7.5a1,1,0,0,0-1,1V5.85H1a1,1,0,0,0-1,1V27.28a1,1,0,0,0,1,1H27a1,1,0,0,0,1-1V6.85A1,1,0,0,0,27,5.85Zm-1,2V9.62a1,1,0,0,0-.86-.52H22.36a1,1,0,0,0-.86.52V7.85ZM21.5,19.41a1,1,0,0,0,.86.52h2.79a1,1,0,0,0,.86-.52v2.75a1,1,0,0,0-.86-.52H22.36a1,1,0,0,0-.86.52Zm3.64-1.48H22.36a1,1,0,0,0-.86.52V14.76a1,1,0,0,0,.86.52h2.79a1,1,0,0,0,.86-.52v3.68a1,1,0,0,0-.86-.52Zm0-4.64H22.36a1,1,0,0,0-.86.52V10.58a1,1,0,0,0,.86.52h2.79a1,1,0,0,0,.85-.52v3.21a1,1,0,0,0-.85-.51Zm-18.64.5a1,1,0,0,0-.86-.51H2.86A1,1,0,0,0,2,13.8V10.58a1,1,0,0,0,.86.52H5.64a1,1,0,0,0,.86-.52ZM2.86,15.28H5.64a1,1,0,0,0,.86-.52v3.68a1,1,0,0,0-.86-.52H2.86a1,1,0,0,0-.86.52V14.76A1,1,0,0,0,2.86,15.28Zm0,4.64H5.64a1,1,0,0,0,.86-.52v2.75a1,1,0,0,0-.86-.52H2.86a1,1,0,0,0-.86.52V19.41A1,1,0,0,0,2.86,19.92ZM6.5,7.85V9.62a1,1,0,0,0-.86-.52H2.86A1,1,0,0,0,2,9.62V7.85ZM2,23.12a1,1,0,0,0,.86.52H5.64a1,1,0,0,0,.86-.52v3.16H2ZM8.5,6.85V2.28h11v24H16.86V22.64a1,1,0,0,0-1-1H12.14a1,1,0,0,0-1,1v3.64H8.5Zm4.64,19.43V23.64h1.71v2.64Zm8.36,0V23.12a1,1,0,0,0,.86.52h2.79a1,1,0,0,0,.86-.52v3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.29,11.1h7.43a1,1,0,0,0,0-2H10.29a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.29,15.28h7.43a1,1,0,0,0,0-2H10.29a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.72,19.92a1,1,0,0,0,0-2H10.29a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.29,6.92h7.43a1,1,0,0,0,0-2H10.29a1,1,0,0,0,0,2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.83858a0312b1ae34d4a8cadf1968da3b.svg";
export { ForwardRef as ReactComponent };